import { Pipe, PipeTransform } from "@angular/core";
import { CaslAction } from "../../server/enums/casl-action.enum";
import { EntityTyp } from "../enums/entity-typ.enum";
import { AppAbility } from "../service/auth.service";

@Pipe({
    name: "permission",
    standalone: false
})
export class PermissionPipe implements PipeTransform {
  constructor(private ability: AppAbility) {}

  transform(action: CaslAction, subject: EntityTyp): boolean {
    if (!action || !subject) return false;

    return this.ability.can(action, subject);
  }
}
